export const DATE_TYPES = {
  month: "month",
  week: "week",
  day: "day"
};
